const ATTRIBUTION_PARAMETERS = Object.freeze([
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  'utm_source_platform',
  'utm_creative_format',
  'utm_marketing_tactic',
  'gclid',
  'dclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'msclkid',
  'ttclid',
  'twclid',
]);

export function withCollectionAttribution(href, search = globalThis.location?.search || '', base = globalThis.location?.href || 'https://alvorn.invalid/') {
  let target;
  let origin;
  try {
    target = new URL(href, base);
    origin = new URL(base).origin;
  } catch {
    return href;
  }
  if (target.origin !== origin) return href;
  const current = new URLSearchParams(search);
  for (const name of ATTRIBUTION_PARAMETERS) {
    if (target.searchParams.has(name)) continue;
    for (const value of current.getAll(name)) target.searchParams.append(name, value);
  }
  return `${target.pathname}${target.search}${target.hash}`;
}

export function preserveCollectionAttribution(root = globalThis.document, search = globalThis.location?.search || '', base = globalThis.location?.href || 'https://alvorn.invalid/') {
  for (const link of root?.querySelectorAll?.('[data-alvorn-attribution-link]') || []) {
    const href = link.getAttribute('href');
    if (href) link.setAttribute('href', withCollectionAttribution(href, search, base));
  }
}

export function preserveCollectionAttributionFromEvent(event, search = globalThis.location?.search || '', base = globalThis.location?.href || 'https://alvorn.invalid/') {
  const link = event.target?.closest?.('[data-alvorn-attribution-link]');
  if (!link) return;
  const href = link.getAttribute('href');
  if (href) link.setAttribute('href', withCollectionAttribution(href, search, base));
}

if (globalThis.document) {
  const apply = () => preserveCollectionAttribution();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
  document.addEventListener('pointerdown', preserveCollectionAttributionFromEvent, true);
  document.addEventListener('click', preserveCollectionAttributionFromEvent, true);
  document.addEventListener('shopify:section:load', (event) => preserveCollectionAttribution(event.target));
}
